<template>
  <div>
    <Loading v-if="loading"/>
    <div v-if="isAuthenticated">
      <AppHeader/>

      <section class="step-progress navbar-space no-padding">
        <div class="container step-container">
          <div class="step-title">
            <h4>การขอ{{reqTypeList[reqType]}} e-LG Blockchain</h4>
          </div>
        </div>
      </section>

      <section class="personal-info-sc">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-8 col-sm-12 col-xl-9 col-xs-fix">
              <div class="additonal-info-wrapper" id="accordion">
                  <div class="card card-form">
                    <div
                      class="card-header first-header card-expandable"
                      id="headingOne"
                      data-toggle="collapse"
                      data-target="#collapseOne"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      <div class="title">
                        <i class="feather-icon icon-file-plus"></i>
                        <h5 class="mb-0">ประเภทการขอออกหนังสือค้ำประกัน</h5>
                      </div>
                    </div>

                    <div class="card-body compact-padding">
                      <div class="compact-padding">
                        <div class="form-row">
                          <div class="form-group col-md-3">
                            <!--<b-form-checkbox
                              v-model="reqTypeNew"
                              value="NEW"
                              unchecked-value=""
                              @change="checkReqType()"
                            >ออกหนังสือค้ำประกัน</b-form-checkbox>-->
                            <b-form-radio ref="reqType" v-model="reqType" v-bind:value="1">ออกหนังสือค้ำประกัน</b-form-radio>
                          </div>
                          <div class="form-group col-md-3">
                            <!--<b-form-checkbox
                              v-model="reqTypeExt"
                              value="EXT"
                              unchecked-value=""
                              @change="checkReqType()"
                            >ต่ออายุหนังสือค้ำประกัน</b-form-checkbox>-->
                            <b-form-radio ref="reqType" v-model="reqType" v-bind:value="2">ต่ออายุหนังสือค้ำประกัน</b-form-radio>
                          </div>
                          <div class="form-group col-md-3">
                            <!--<b-form-checkbox
                              v-model="reqTypeInc"
                              value="INC"
                              unchecked-value=""
                              @change="checkReqType()"
                            >เพิ่มวงเงินหนังสือค้ำประกัน</b-form-checkbox>-->
                            <b-form-radio ref="reqType" v-model="reqType" v-bind:value="3" >เพิ่มวงเงินหนังสือค้ำประกัน</b-form-radio>
                          </div>
                          <div class="form-group col-md-3">
                            <!--<b-form-checkbox
                              v-model="reqTypeInc"
                              value="INC"
                              unchecked-value=""
                              @change="checkReqType()"
                            >เพิ่มวงเงินหนังสือค้ำประกัน</b-form-checkbox>-->
                            <b-form-radio ref="reqType" v-model="reqType" v-bind:value="4">ต่ออายุ+เพิ่มวงเงิน</b-form-radio>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- <keep-alive></keep-alive> -->
                      <component :reqType="reqType" :is="dynamicType"/>
                    

                    <!--hidden field-->
                    <!--<input type="hidden" v-model="reqNo">-->
                  </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <AppFooter/>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import AppFooter from "../pagecomp/appFooter";
import AppHeader from "../pagecomp/appHeader";
import { AUTH_LOGOUT } from "@/store/actions/auth";
import { mapGetters } from "vuex";
import axios from "axios";
import Loading from "@/components/lib/loading";

import { apiClient } from "@/utils/apiClient";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
//import DatePicker from "vue2-datepicker";
import DatePicker from "@/resources/datepicker/vue2-datepicker";

export default {
  props: ["beneCode", "lg"],
  components: {
    AppFooter,
    AppHeader,
    vueDropzone: vue2Dropzone,
    DatePicker
  },
  name: "requestMain",
  watch: {
    reqType(newVal, oldVal) {
      /*if (newVal !== "1") {
        alert();
         return () => import(`@/components/request/extend`);
      }*/

      this.dynamicType();

      console.log("newVal=" + newVal);
      console.log("oldVal=" + oldVal);
    },

    periodStartDate1(newDate, oldDate) {
      console.log("main-newDate=" + newDate);
      console.log("main-oldDate=" + oldDate);
    }
  },

  computed: {
    ...mapGetters(["isAuthenticated", "authStatus"]),
    loading: function() {
      return this.authStatus === "loading" && !this.isAuthenticated;
    },

    dynamicType() {

      if (this.reqType == 1) {
        //ออกใหม่
        return () => import(`@/components/request/new`);
      } else {
        return () => import(`@/components/request/extend`);
      }
    },

    dynamicBene() {
      const beneCode = localStorage.getItem("beneGroup");
      const lgType = localStorage.getItem("lgType");
      console.log(this.reqType+":main: "+ beneCode + "  :  " + lgType);
      // const beName = this.beneCode
      //if (beneCode === undefined) {
      //  return () => import(`@/components/request/default`);
      //}

      if (this.reqType == 1) {
        //ออกใหม่
        return () => import(`@/components/request/new/${beneCode}_${lgType}`);
      } else {
        return () => import(`@/components/request/extend/${beneCode}_${lgType}`);
      }

      
      // return () => import(`@/components/request/default`);
    }
  },
  methods: {
    /*getLgTypeList: function() {
      //console.log("taxid:"+taxid);
      apiClient.get("/api/home/getBeneficiaryProfile/"+beneficiary.beneTaxId).then(resp => {
        this.custLgTypeList = resp.data;
      });
    },*/

  },
  data() {
    return {
      reqNo: "",
      reqType: 1,
      appVo: [],
      beneficiary: {
        beneTaxId: localStorage.getItem("beneTaxId"),
        beneGroup: localStorage.getItem("beneGroup")
      },
      beneficiaryList: [],
      lgType: localStorage.getItem("lgType"),
      custLgTypeList: [],
      commList: [], //[{"commNo":"10000010000","amt":"10000000.00"},{"commNo":"10000020000","amt":"20000000.00"}],
      periodType: 1,
      accountNo: "",
      majorStampAmt: "",
      minorStampAmt: "",
      dutyStampAmt: "",
      periodStartDate: "",
      periodStartDate1: "",
      periodStartDate2: "",
      periodEndDate: "",

      extPeriodType: 2,
      extPeriodStartDate1: "",
      extPeriodStartDate2: "",
      extPeriodEndDate: "",
      reqTypeList:["","ออกหนังสือค้ำประกัน","ต่ออายุหนังสือค้ำประกัน","เพิ่มวงเงินหนังสือค้ำประกัน","ต่ออายุ+เพิ่มวงเงิน"]
    };
  },
  mounted() {
    // let tokenStr = localStorage.getItem("user-token");
    //localStorage.setItem("cifNo", "29956303");
    apiClient
      .get(
        "/api/elg/defaultRequest/" +
          localStorage.getItem("registerVerifyId")
      )
      .then(resp => {
        this.appVo = resp.data;
        this.reqNo = resp.data.reqNo;
        this.commList = resp.data.accountLimit;
        this.majorStampAmt = resp.data.majorStampAmt;
        this.minorStampAmt = resp.data.minorStampAmt;
        this.dutyStampAmt = resp.data.dutyStampAmt;
      });

    apiClient.get("/api/home/getBeneficiary").then(resp => {
      this.beneficiaryList = resp.data;
    });

    apiClient
      .get(
        "/api/home/getBeneficiaryProfile/" + localStorage.getItem("beneTaxId")
      )
      .then(resp => {
        this.custLgTypeList = resp.data;
      });

    // this.lgAmt = localStorage.getItem("amount");
  }
};
</script>
